import { markSlice } from "./store/mark.slice";
import {
  markApi,
  useGetMarksQuery,
  useCreateMarkMutation,
  useUpdateMarkMutation,
  useLazyGetMarkByIdQuery,
  useLazyGetMarksQuery,
  useDeleteAllMarksMutation,
  useDeleteMarkMutation,
  useImportPreviewMutation,
  useImportConfirmMutation,
} from "./api/mark.api";

export const { setMarks } = markSlice.actions;

export {
  markApi,
  markSlice,
  useGetMarksQuery,
  useCreateMarkMutation,
  useUpdateMarkMutation,
  useLazyGetMarkByIdQuery,
  useLazyGetMarksQuery,
  useDeleteAllMarksMutation,
  useDeleteMarkMutation,
  useImportPreviewMutation,
  useImportConfirmMutation,
};
